module.exports = __webpack_public_path__ + "img/bsv_teranode.9559455.png";